import {
  NEW_TAXONOMY_COOKIE_ID,
  TAXONOMY_EXPERIMENT_ID,
} from '../../services/useVariation';

import {
  updateABTestCookie,
  verifyExperimentQueryParam,
} from '../serverSideUtils';

export function verifyAndUpdateTaxonomyCookie(asPath, res, isNewTaxonomy) {
  if (
    verifyExperimentQueryParam(asPath, isNewTaxonomy, TAXONOMY_EXPERIMENT_ID)
  ) {
    updateABTestCookie(res, isNewTaxonomy, NEW_TAXONOMY_COOKIE_ID);
  }
}
